
'use strict';

module.exports = function (angular, app) {
  app.service('DeepQueryDimensions', [
      "$rootScope", 
      "$http", 
      "$localStorage", 
      function ($rootScope, $http, $localStorage) {
        var metricsRe = /^(.*):(max|min|sum|unique)$/;
        var _dimensions = {};

      function getDimensions(source) {
          return new Promise((resolve) => {
              if (_dimensions[source]) {
                  $rootScope.$broadcast('dimensions-loaded', _dimensions[source]);
                  return resolve(_dimensions[source]);
              }

              $http.get('/-/dimensions/' + source).then((response) => {
                  var columns = response.data,
                      dimensionIndex = {},
                      dimensionNames = [],
                      metrics = {};

                  angular.forEach(columns, function(column) {
                      var columnName = column.name;
                      dimensionIndex[columnName] = column;
                      var match = columnName.match(metricsRe);

                      if (match) {
                          metrics[match[1]] = true;
                      } else {
                          dimensionNames.push(columnName);
                      }
                  });

                  for(var metricName in metrics) {
                      if (!(metricName in dimensionIndex)) {
                          dimensionNames.push(metricName);
                      }
                  }

                  _dimensions[source] = {
                      index: dimensionIndex,
                      names: dimensionNames.sort(function (a, b) {
                        return a.toLowerCase().localeCompare(b.toLowerCase());
                      })
                  };
                  $localStorage.dataViewsSource = source;

                  $rootScope.$broadcast('dimensions-loaded', _dimensions[source]);
                  resolve(_dimensions[source]);
              });
          });
      }

      function getNames(source) {
          return this.get(source).then(function(dim) {
              return dim.names;
          });
      }

      function getNamesFiltered(source, filter, threshold) {
          threshold || (threshold = 4);
          return this.getNames(source).then(function(names) {
              if (angular.isString(filter)) {
                  filter = filter.toLowerCase();
                  var flen = filter.length;
                  if (flen < threshold) {
                      return names.filter(function(name) {
                          return name.substr(0, flen).toLowerCase() === filter;
                      });
                  } else {
                      return names.filter(function(name) {
                          return name.toLowerCase().indexOf(filter) >= 0;
                      });
                  }
              } else if (angular.isFunction(filter)) {
                  return names.filter(filter);
              } else
                  return names;
          });
      }

      return {
          getNames: getNames,
          getDimensions: getDimensions,
          getNamesFiltered: getNamesFiltered
      }
  }]);
};
